import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import { catalogItemShape } from '../_common_/propTypes';
import Dot from '../../ReusableComponents/Dot/Dot';
import TextButton from '../../ReusableComponents/TextButton';
import styles from './DimensionsStatus.module.css';
import {
  countMissingDetails,
  MAX_MISSING_DETAILS,
} from '../utils/countMissingDetails';

export default function DimensionsStatus({
  catalogItem,
  onDimensionOpen,
  minimized = false,
  perms,
}) {
  const missingDetailsCount = countMissingDetails(catalogItem);

  return (
    <div>
      <Dot color={missingDetailsCount === 0 ? 'green' : 'red'} />
      {missingDetailsCount === MAX_MISSING_DETAILS ||
      (missingDetailsCount && minimized)
        ? perms.canUpdateSizeAndWeight && (
            <TextButton onClick={() => onDimensionOpen(catalogItem)}>
              Add
            </TextButton>
          )
        : !minimized && (
            <>
              {`${catalogItem.width || ' _ '}x${
                catalogItem.height || ' _ '
              }x${catalogItem.length || ' _ '} •  ${
                catalogItem.weight || ' _ '
              } lbs`}
              {perms.canUpdateSizeAndWeight && (
                <button
                  type="button"
                  data-testid="editIcon"
                  onClick={() => onDimensionOpen(catalogItem)}
                  className={styles.editButton}
                  aria-label="Edit"
                >
                  <EditIcon fontSize="small" />
                </button>
              )}
            </>
          )}
    </div>
  );
}

DimensionsStatus.propTypes = {
  catalogItem: catalogItemShape.isRequired,
  onDimensionOpen: PropTypes.func.isRequired,
  minimized: PropTypes.bool,
};
